import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import { Box, Toolbar } from '@mui/material';
import DashboardPage from './pages/DashboardPage';
import WorkoutsPage from './pages/WorkoutsPage';
import PerformancePage from './pages/PerformancePage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminPlayerListPage from './pages/AdminPlayerListPage';
import AdminRoute from './components/AdminRoute';
import AdminPlayerDetailPage from './pages/AdminPlayerDetailPage';
import AdminBuildWorkoutPage from './pages/AdminBuildWorkoutPage';
import PlayerLoginPage from './pages/PlayerLoginPage';
import SignupPage from './pages/SignupPage';

function App() {
  return (
    <Router>
      <Box sx={{ display: 'flex' }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Toolbar />
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/workouts" element={<WorkoutsPage />} />
            <Route path="/performance" element={<PerformancePage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/player/login" element={<PlayerLoginPage />} />
            <Route 
              path="/admin/dashboard" 
              element={
                <AdminRoute>
                  <AdminDashboardPage />
                </AdminRoute>
              } 
            />
            <Route 
              path="/admin/players" 
              element={
                <AdminRoute>
                  <AdminPlayerListPage />
                </AdminRoute>
              } 
            />
            <Route
              path="/admin/players/:userId"
              element={
                <AdminRoute>
                  <AdminPlayerDetailPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/build-workout"
              element={
                <AdminRoute>
                  <AdminBuildWorkoutPage />
                </AdminRoute>
              }
            />
            <Route path="player/signup" element={<SignupPage />} />

          </Routes>
        </Box>
      </Box>
    </Router>
  );
}

export default App;

